import jQuery from 'jquery';
let $ = jQuery;
import __extends from 'LIBS/extend.js';

import "LIBS/jquery.showhtml.js";

// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.BrandsEditModal
*
* Encapsulates the functionality of a modal dialog that contains email friend form
**/
HSN.BrandsEditModal = (function (parent) {
    __extends(brandsEditModal, parent);

    /**
    * new HSN.brandsEditModal()
    **/
    function brandsEditModal() {
        this.name = 'HSN.BrandsEditModal';
        var modal = brandsEditModal.__super__.constructor.call(this);
        this.Close.off();
        eventHandlers(this);
        return modal;
    }
    brandsEditModal.prototype._hide = function () {
    };

    function eventHandlers (modal) {
        $(modal.Close).on('click', function (e) {
            closeModal(e, modal);
        });
    }

    function closeModal (e, modal) {
        modal.Hide();
        HSN.Instance().Events.Trigger(HSN.Modal.EVENT.MODAL_CLOSE);
    }

    /**
    * - url (string): route to retrieve data from
    * - data: javascript object to pass to ajax call
    *
    * Display the modal and load in the information for the given product identifier.
    **/
    brandsEditModal.prototype._show = function (url, webPId, title, photoUrl, imageDescription, productUrl) {

        var scope = this;
        brandsEditModal.url = url;

        $.ajax(url + "?" + new Date().getTime(), {
            dataType: 'html',
            data: { 'WebPId': webPId, 'Title': title, 'PhotoUrl': photoUrl, 'ImageDescription': imageDescription, 'ProductUrl': productUrl },
            success: function (htmlData) {
                scope.Root.removeClass('loading');
                scope.DisplayModal(htmlData, 0);
            },
            error: function () {
                alert("Unfortunately there was an error attempting to load the content, please try again.");
                $('#modal-mask').remove();
            }
        });
    };

    /**
    * Submit for recommend a friend, use ajax to retrieve response, and update modal content
    **/
    brandsEditModal.prototype.SubmitEmailFriendForm = function (saveData) {

        var scope = this;
        var brandsEditForm = $('form', scope.Root);
        var formData = brandsEditForm.serializeArray();
        formData[formData.length] = { name: 'saveData', value: saveData };

        $.ajax({
            type: 'POST',
            url: '/myaccount/communicationpreferences/brandsedit/brands-edit-post',
            dataType: 'json',
            contentType: 'application/x-www-form-urlencoded',
            data: formData
        })
            .done(function (data) {
                if (data.success) {
                    $('div.errors').remove();
                    jQuery("#BrandsEditModal").hide();
                    jQuery("#BrandsEditModalSucess").show();
                }
                else {
                    HSN.AddErrorTreatment('#brandsEditForm', data);
                }
            })
            .fail(function () {
                alert('error submitting the request');
            });

    };

    brandsEditModal.prototype.DisplayModal = function (data, time) {
        var scope = this;
        this.Content.showHtml(data, time, function () {
            var deviceInfo = HSN.Instance().DeviceInformation;
            scope.Center(-300, -300);
            
            if (deviceInfo.IsMobile && !deviceInfo.IsTablet) {
                scope.Center(0, 0);
            }
           
            scope.Content.animate({ opacity: 1 }, function() {
                var elemetToFocus = scope.Content.find('.brands-edit-modal');
                scope.SetFocus(elemetToFocus);
            });
        });
    };
    return brandsEditModal;

})(HSN.Modal);




// WEBPACK FOOTER //
// ./assets/js/HSN/BrandsEditModal.js